export const name = "Quarantine Edition"
export const menu = "Quarantine"
export const edition = "Quarantine Edition"
export const suggestedPlayer = "2+ players"
export const color = {
    primary: {
        main:  '#c10016',
        contrastText: '#ffffff',
    },
    secondary: {
        main:  '#c10016',
    }
}
export const levels = ['Level 1 Perception', 'Level 2 Connection', 'Level 3 Reflection', 'Final Card']
export const isExpansion = false

export const backDesc = [
    "Physically distant\n Emotionally Connected"
]

export const level1 = [
    "What time do you\n think I've been\n waking up these days?",
    "What do you think\n I've been binge\n watching lately?",
    "Do you think\n I'm mainly cooking\n or postmating?",
    "What do you think\n has been my go to\n snack during this time?",
]

export const level2 = [
    "When quarantining is behind us, what change do you want to make in your day to day life if any?",
    "What can you create during this time with exactly what you have? Big or small.",
    "What's been the kindest thing someone has done for you during this time? What's been the kindest thing you've done for yourself?",
    "What would feel best to fully accept in this current moment?",
    "What are you most excited for today? Big or small?",
    "What has been the hardest part of all this for you? Permission to vent.",
    "What movie do you wish you'd never seen so you can watch it for the first time during quarantine?",

    "Wild Card Staring contest. First\n to smile must reveal\n what their kitchen looks\n like in the current moment.",
    "Wild Card Share your most played song at the moment",
    "Wild Card Share your screen time. Both players."
]

export const level3 = [
    "If you made a playlist for me,\n what 3 songs would be on it?",
    "What do I need to watch\n as soon as I have the time?",
    "How can I best be there\n for you during this chapter?",
    "Wild Card Who's been on your mind lately?\n Send them a text letting them know\n you're thinking of them.\n Both players."
]

export const finalCard = [
    "Each player write a\n virtual message to your\n partner. Press send once you\n two have hung up."
]